import { createSlice } from '@reduxjs/toolkit';
import { workScheduleApi } from 'features/work-schedule/query';
import { type TWorkScheduleState } from 'features/work-schedule/types';

const initialState: TWorkScheduleState = {
  workScheduleEvents: null,
  workScheduleDetail: null,
  isFetchingWorkScheduleDetail: false,
};

const workScheduleSlice = createSlice({
  name: 'workSchedule',
  initialState,
  reducers: {},
  extraReducers: builder => {
    const { GetWorkScheduleList, GetWorkScheduleDetail } =
      workScheduleApi.endpoints;

    builder
      .addMatcher(GetWorkScheduleList.matchFulfilled, (state, { payload }) => {
        state.workScheduleEvents = payload;
      })
      .addMatcher(GetWorkScheduleDetail.matchPending, state => {
        state.workScheduleDetail = null;
        state.isFetchingWorkScheduleDetail = true;
      })
      .addMatcher(
        GetWorkScheduleDetail.matchFulfilled,
        (state, { payload }) => {
          state.workScheduleDetail = payload;
          state.isFetchingWorkScheduleDetail = false;
        }
      )
      .addMatcher(GetWorkScheduleDetail.matchRejected, state => {
        state.workScheduleDetail = null;
        state.isFetchingWorkScheduleDetail = false;
      });
  },
});

export const workScheduleReducer = workScheduleSlice.reducer;
